const texts = {
    "upload-image-intro": {
        EN: "Upload an image where the defect is clearly visible",
        DA: "Upload et billede hvor defekten er tydeligt synlig",
        DE: "Laden Sie ein Bild hoch, auf dem der Defekt deutlich sichtbar ist",
        NL: "Upload een afbeelding waarop het defect duidelijk zichtbaar is",
        FR: "Téléchargez une image où le défaut est clairement visible",
        IT: "Carica un'immagine in cui il difetto sia chiaramente visibile",
        ES: "Sube una imagen donde el defecto sea claramente visible",
        PT: "Carregue uma imagem onde o defeito seja claramente visível",
        FI: "Lataa kuva jossa vika näkyy selvästi",
        SV: "Ladda upp en bild där defekten syns tydligt",
        NO: "Last opp et bilde der feilen er tydelig synlig",
    },
    "no-thanks-prefer-refund": {
        EN: "No, thank you, I prefer a refund",
        DA: "Nej tak, jeg foretrækker en refusion",
        DE: "Nein danke, ich bevorzuge eine Rückerstattung",
        NL: "Nee bedankt, ik geef de voorkeur aan een terugbetaling",
        FR: "Non merci, je préfère un remboursement",
        IT: "No grazie, preferisco un rimborso",
        ES: "No gracias, prefiero un reembolso",
        PT: "Não, obrigado, prefiro um reembolso",
        FI: "Ei kiitos, haluan mieluummin hyvityksen",
        SV: "Nej tack, jag föredrar en återbetalning",
        NO: "Nei takk, jeg foretrekker refusjon",
    },
    "complaint-qr-explanation": {
        EN: "Scan the QR code using your phone's camera app",
        DA: "Scan QR-koden med din telefons kamera-app",
        DE: "Scannen Sie den QR-Code mit der Kamera-App Ihres Telefons",
        NL: "Scan de QR-code met de camera-app van je telefoon",
        FR: "Scannez le code QR avec l'application appareil photo de votre téléphone",
        IT: "Scansiona il codice QR con l'app fotocamera del tuo telefono",
        ES: "Escanea el código QR con la aplicación de cámara de tu teléfono",
        PT: "Escaneie o código QR usando o aplicativo de câmera do seu telefone",
        FI: "Skannaa QR-koodi puhelimesi kamerasovelluksella",
        SV: "Skanna QR-koden med mobilens kameraapp",
        NO: "Skann QR-koden ved å bruke telefonens kameraapp",
    },
    "complaint-upload-computer": {
        EN: "Upload from computer",
        DA: "Upload fra computer",
        DE: "Vom Computer hochladen",
        NL: "Vanaf computer uploaden",
        FR: "Importer depuis l'ordinateur",
        IT: "Carica dal computer",
        ES: "Subir desde el ordenador",
        PT: "Carregar do computador",
        FI: "Lataa tietokoneelta",
        SV: "Ladda upp från datorn",
        NO: "Last opp fra datamaskinen",
    },
    "complaint-upload-phone": {
        EN: "Upload image",
        DA: "Upload billede",
        DE: "Bild hochladen",
        NL: "Afbeelding uploaden",
        FR: "Importer une image",
        IT: "Carica immagine",
        ES: "Subir imagen",
        PT: "Carregar imagem",
        FI: "Lataa kuva",
        SV: "Ladda upp en bild",
        NO: "Last opp bilde",
    },
    "complaint.required-text": {
        EN: "Please use at least 5 characters to describe your complaint",
        DA: "Brug venligst mindst 5 tegn til at beskrive din klage",
        DE: "Bitte verwenden Sie mindestens 5 Zeichen, um Ihre Beschwerde zu beschreiben",
        NL: "Gebruik minimaal 5 tekens om je klacht te beschrijven",
        FR: "Veuillez utiliser au moins 5 caractères pour décrire votre réclamation",
        IT: "Utilizza almeno 5 caratteri per descrivere il tuo reclamo",
        ES: "Por favor usa al menos 5 caracteres para describir tu reclamación",
        PT: "Use pelo menos 5 caracteres para descrever sua reclamação",
        FI: "Käytä vähintään 5 merkkiä kuvaamaan valitustasi",
        SV: "Ange minst 5 tecken för att beskriva din reklamation",
        NO: "Bruk minst 5 tegn for å beskrive klagen din",
    },
    "complaint.required-img": {
        EN: "You need to upload an image to your complaint",
        DA: "Du skal uploade et billede til din klage",
        DE: "Sie müssen ein Bild zu Ihrer Reklamation hochladen",
        NL: "Je moet een afbeelding uploaden bij je klacht",
        FR: "Vous devez télécharger une image pour votre réclamation",
        IT: "Devi caricare un'immagine per il tuo reclamo",
        ES: "Necesitas subir una imagen con tu reclamación",
        PT: "Você precisa carregar uma imagem para sua reclamação",
        FI: "Sinun täytyy ladata kuva valituksesi tueksi",
        SV: "Du måste ladda upp en bild till din reklamation",
        NO: "Du må laste opp et bilde til klagen din",
    },
    "complaint.success": {
        EN: "Successfully uploaded image!",
        DA: "Billede uploadet med succes!",
        DE: "Bild erfolgreich hochgeladen!",
        NL: "Afbeelding succesvol geüpload!",
        FR: "Image téléchargée avec succès!",
        IT: "Immagine caricata con successo!",
        ES: "¡Imagen subida con éxito!",
        PT: "Imagem carregada com sucesso!",
        FI: "Kuva ladattu onnistuneesti!",
        SV: "Bilden har laddats upp!",
        NO: "Bildet ble lastet opp!",
    },
    "complaint.go-to-device": {
        EN: "Go back to your original device and continue your claim. b{It can take up to 5 seconds} before your uploaded image shows on your device.",
        DA: "Gå tilbage til din oprindelige enhed og fortsæt din klage. b{Det kan tage op til 5 sekunder}, før dit uploadede billede vises på din enhed.",
        DE: "Gehen Sie zurück zu Ihrem ursprünglichen Gerät und setzen Sie Ihre Beschwerde fort. b{Es kann bis zu 5 Sekunden dauern}, bis Ihr hochgeladenes Bild auf Ihrem Gerät erscheint.",
        NL: "Ga terug naar je oorspronkelijke apparaat en ga verder met je claim. b{Het kan tot 5 seconden duren} voordat je geüploade afbeelding op je apparaat verschijnt.",
        FR: "Retournez sur votre appareil d'origine et poursuivez votre réclamation. b{Cela peut prendre jusqu'à 5 secondes} avant que votre image téléchargée apparaisse sur votre appareil.",
        IT: "Torna al dispositivo originale e continua il reclamo. b{Può richiedere fino a 5 secondi} prima che l'immagine caricata compaia sul dispositivo.",
        ES: "Vuelve a tu dispositivo original y continúa con tu reclamación. b{Puede tardar hasta 5 segundos} en que la imagen subida aparezca en tu dispositivo.",
        PT: "Volte para o dispositivo original e continue sua reclamação. b{Pode levar até 5 segundos} para que a imagem carregada apareça no dispositivo.",
        FI: "Palaa alkuperäiselle laitteellesi ja jatka valitustasi. b{Kuvan näkymisessä voi kestää jopa 5 sekuntia}.",
        SV: "Gå tillbaka till din ursprungliga enhet och fortsätt din reklamation. b{Det kan ta upp till 5 sekunder} innan den uppladdade bilden visas på din enhet.",
        NO: "Gå tilbake til den opprinnelige enheten og fortsett klagen. b{Det kan ta opptil 5 sekunder} før det opplastede bildet vises på enheten.",
    },
    "complaint-reasons-post-message": {
        EN: "",
        DA: "",
        DE: "",
        NL: "",
        FR: "",
        IT: "",
        ES: "",
        PT: "",
        FI: "",
    },
};
export default texts;
